import control from './controls/control';
import constants from './constants';

const getExtension = () => ({
  slug: constants.common.slug,
  title: 'WS Gallery Customizer',
  description: 'Extension for editing image gallery',
  settings: {
    querySelector:
      '[id*="ws-block-gallery"] ws-media-container[origin-src], [id*="ws-block-widget-gallery"] ws-media-container[origin-src], [id*="ws-block-slider-gallery"] ws-media-container[origin-src], [src*="/cover-splitscreen-with-slider/"] ws-media-container[origin-src]',
    galleryBlockQuerySelector:
      '[id*="ws-block-gallery"], [id*="ws-block-widget-gallery"], [id*="ws-block-slider-gallery"], [src*="/cover-splitscreen-with-slider/"]',
    sliderGalleryBlockQuerySelector:
      '[id*="ws-block-slider-gallery"], [src*="/cover-splitscreen-with-slider/"]',
    galleryQuerySelector: 'ws-columns, ws-slider',
    galleryWidgetQuerySelector: '[id*="ws-block-widget-gallery"]',
    defaultAssetsPathPrefix: '/ws/blocks/',
    galleryItemSelector: 'ws-media-container[origin-src]',
    sliderGalleryItemSelector:
      'ws-slider-item[data-ws-id], ws-slider-item:not([data-ws-id]) > ws-media-container, ws-column, figure',
  },
  ui: {
    control: [control],
  },
});

export default getExtension;
